import { render, staticRenderFns } from "./EachCountryKeyServiceGreetings.vue?vue&type=template&id=0fcf0678&scoped=true&"
import script from "./EachCountryKeyServiceGreetings.vue?vue&type=script&lang=js&"
export * from "./EachCountryKeyServiceGreetings.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryKeyServiceGreetings.vue?vue&type=style&index=0&id=0fcf0678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf0678",
  null
  
)

export default component.exports